import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import CommonSelect from "../../core/common/commonSelect";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import {
  getEmployeeById,
  getEmployeeByUserId,
  getEmployees,
} from "../../core/data/redux/employee/employeeAction";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../core/data/redux/store";
import { fetchAllKRA } from "../../core/data/redux/performance/KRA/kraAction";
import { createSelfappraisal } from "../../core/data/redux/performance/appraisal/appraisalAction";
import { createappliedappraisal } from "../../core/data/redux/performance/appliedappraisal/appliedappraisalAction";
import { createachievemnet } from "../../core/data/redux/performance/achievement/achievementAction";
import { createcomment } from "../../core/data/redux/performance/comment/commentAction";
import { createpersonalgoal } from "../../core/data/redux/performance/personalgoal/personalgoalAction";

import { fetchAllRoleindicator } from "../../core/data/redux/performance/roleindicator/roleindicatorAction";
import { message } from "antd";

const StarRating = ({
  rating,
  onRate,
}: {
  rating: number;
  onRate: (rating: number) => void;
}) => {
  const handleClick = (star: number, isHalf: boolean) => {
    const newRating = isHalf ? star - 0.5 : star;
    onRate(newRating);
  };

  return (
    <div style={{ display: "flex", gap: "4px" }}>
      {[1, 2, 3, 4, 5].map((star) => (
        <div
          key={star}
          style={{ position: "relative", fontSize: "24px", cursor: "pointer" }}
        >
          <span
            style={{
              position: "absolute",
              width: "50%",
              overflow: "hidden",
              color: rating >= star - 0.5 ? "gold" : "gray",
            }}
            onClick={() => handleClick(star, true)}
          >
            ★
          </span>

          <span
            style={{
              color: rating >= star ? "gold" : "gray",
            }}
            onClick={() => handleClick(star, false)}
          >
            ★
          </span>
        </div>
      ))}
    </div>
  );
};

interface PerformanceSelfReviewProps {
  onClose: () => void;
}

const PerformanceSelfReview: React.FC<PerformanceSelfReviewProps> = ({
  onClose,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [employeedata, setEmployeedata] = useState<any>([]);
  const [formData, setFormData] = useState<any>({});
  const [employeeExprience, setemployeeExprience] = useState<any>([]);
  const { kra } = useSelector((state: any) => state.performance.kra);
  const [data, setdata] = useState<any[]>([]);
  const [goals, setGoals] = useState<
    { id: any; lastYearGoal: string; currentYearGoal: string }[]
  >([{ id: 1, lastYearGoal: "", currentYearGoal: "" }]);
  const { roleindicator } = useSelector(
    (state: any) => state.performance.roleindicator
  );
  const [filteredRoleIndicators, setFilteredRoleIndicators] = useState<any[]>(
    []
  );
  const [currentDate, setCurrentDate] = useState("");

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setCurrentDate(today);
  }, []);

  useEffect(() => {
    if (employeedata.length > 0 && roleindicator.length > 0) {
      const uniqueDesignationIds = Array.from(
        new Set(employeedata.map((emp: any) => emp.DesignationId))
      );
      const matchedRoleIndicators = roleindicator.filter((role: any) =>
        uniqueDesignationIds.includes(role.DesignationId)
      );

      setFilteredRoleIndicators(matchedRoleIndicators);
    }
  }, [employeedata, roleindicator]);

  const { user } = useSelector((state: any) => state.auth);
  const { employeesbyUser } = useSelector((state: any) => state.employee);
  const { employee } = useSelector((state: any) => state.employee);
  const targetUserId = user.UserId;

  const [rows, setRows] = useState([{ id: 1, value: "" }]);
  const [comment, setComment] = useState("");
  const [employeeformData, setEmployeeFormData] = useState({
    name: employeedata?.[0]?.Name,
    frequency: "Monthly",
    rating: 0,
    date: new Date().toISOString().split("T")[0],
  });

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setFormData((prev: any) => ({ ...prev, date: today }));
  }, []);

  const handleEmployeeInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setEmployeeFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEmployeeRatingChange = (newRating: number) => {
    setEmployeeFormData((prev) => ({ ...prev, rating: newRating }));
  };

  const handleemployeeSubmit = (e: any) => {
    e.preventDefault();
    const payload = {
      ...employeeformData,
      employeeId: employeedata[0]?.EmployeeID,
      name: employeedata?.[0]?.Name,
    };

    dispatch(createappliedappraisal(payload)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
      message.success(res.payload.message);
        setTimeout(() => {
          onClose();
        }, 1000);
      } else {
        message.warning(res.payload.error);
      }
    });
  };

  const handleChangeemployee = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev: any) => ({ ...prev, [name]: value }));
  };

  const handleInputChangeComment = (id: number, value: string) => {
    setRows((prevRows) =>
      prevRows.map((row) => (row.id === id ? { ...row, value } : row))
    );
  };

  const handleAddRow = () => {
    setRows([...rows, { id: rows.length + 1, value: "" }]);
  };

  const handleSubmitachivement = () => {
    const payload = {
      achievements: rows.map((row) => row.value),
      createdBy: user.UserId,
      employeeId: employeedata[0]?.EmployeeID || null,
    };

    dispatch(createachievemnet(payload)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        message.success(" Achievement Save Successfully");
      } else {
        message.warning(res.payload.error);
      }
    });
  };

  const handleSaveComment = () => {
    const payload = {
      self_comment: comment,
      createdBy: user.UserId,
      employeeId: employeedata[0]?.EmployeeID || null,
    };
    dispatch(createcomment(payload)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        message.success("Comment Save Successfully");
      } else {
        message.warning(res.payload.error);
      }
    });
  };

  const handleRemoveRow = (id: number) => {
    if (rows.length > 1) {
      setRows(rows.filter((row) => row.id !== id));
    }
  };

  const handleInputChangegoal = (
    id: number,
    field: "lastYearGoal" | "currentYearGoal",
    value: string
  ) => {
    setGoals((prevGoals) =>
      prevGoals.map((goal) =>
        goal.id === id ? { ...goal, [field]: value } : goal
      )
    );
  };

  const addRow = () => {
    const newId =
      goals.length > 0 ? Math.max(...goals.map((g) => g.id)) + 1 : 1;
    setGoals([...goals, { id: newId, lastYearGoal: "", currentYearGoal: "" }]);
  };

  const removeRow = (id: number) => {
    setGoals(goals.filter((goal) => goal.id !== id));
  };

  const handleSubmitgoal = (e: React.FormEvent) => {
    e.preventDefault();
    const payload = {
      employeeId: employeedata[0].EmployeeID,
      goals,
    };
    dispatch(createpersonalgoal(payload)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        message.success("Personal Goal Successfully");
      } else {
        message.warning(res.payload.error);
      }
    });
  };

  useEffect(() => {
    dispatch(getEmployeeByUserId({ userId: targetUserId })).then((res) => {
      dispatch(
        getEmployeeById({ employeeId: res?.payload.data.employeeId })
      ).then((res) => {
        setEmployeedata(res.payload.data.employee);
        setemployeeExprience(res.payload.data.experience);
      });
    });
  }, [dispatch]);

  const handleInputChange = (
    roleId: number,
    groupSerialNo: number,
    value: string,
    weightage: number
  ) => {
    const numericValue = parseInt(value, 10);

    if (numericValue > weightage) {
      return;
    }

    setFormData((prevData: any) => ({
      ...prevData,
      [`${roleId}_${groupSerialNo}`]: numericValue,
    }));
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    if (filteredRoleIndicators.length === 0) {
      alert("No role data available");
      return;
    }
    const selectedRole = filteredRoleIndicators[0];

    const structuredData = {
      roleId: selectedRole.Id,
      roleName: selectedRole.Name,
      roleGroups: selectedRole.role_groups.map((group: any) => {
        const kraName =
          group.indicators.length > 0
            ? group.indicators[0]?.kra.name
            : "No KRA";

        const matchedKRA = kra.find((item: any) => item.kra_name === kraName);
        const kraId = matchedKRA ? matchedKRA.id : null;

        return {
          serialNo: group.serial_no,
          keyResultArea: kraId,
          keyPerformanceIndicators:
            group.indicators.length > 0
              ? group.indicators.map(
                  (indicator: any) => indicator.indicator.name
                )
              : ["No Indicators"],
          weightage: group.weightage,
          pointsScored:
            formData[`${selectedRole.Id}_${group.serial_no}`] || "Not Entered",
        };
      }),
      createdBy: user.UserId,
      employeeId: employeedata[0].EmployeeID,
    };

    dispatch(createSelfappraisal(structuredData)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        alert("Created Successfully");
      } else {
        alert(res.payload.error);
      }
    });
  };

  useEffect(() => {
    dispatch(fetchAllRoleindicator());
    dispatch(fetchAllKRA());
  }, [dispatch]);

  const routes = all_routes;

  return (
    <>
      <div className="content">
        {/* Breadcrumb */}
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Performance Self-Review</h2>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.adminDashboard}>
                    <i className="ti ti-smart-home" />
                  </Link>
                </li>
                <li className="breadcrumb-item">Performance</li>
                <li className="breadcrumb-item active" aria-current="page">
                  Performance Self-Review
                </li>
              </ol>
            </nav>
          </div>
          <div className="head-icons ms-2">
            <CollapseHeader />
          </div>
        </div>
        {/* /Breadcrumb */}

        <section className="card border-0">
          <div className="card-header border border-bottom-0 text-center">
            <h3 className="mb-2">Employee Information</h3>
          </div>
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <div className="table-responsive">
                <form>
                  <table className="table table-bordered table-nowrap mb-0">
                    <tbody>
                      <tr>
                        <td>
                          <div className="mb-3">
                            <label className="form-label" htmlFor="name">
                              Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="name"
                              value={employeedata?.[0]?.Name}
                              disabled
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label" htmlFor="department">
                              Department
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="department"
                              value={employeedata?.[0]?.department_name}
                              disabled
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label" htmlFor="designation">
                              Designation
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="designation"
                              value={employeedata?.[0]?.designation_name}
                              disabled
                            />
                          </div>
                          <div className="mb-3">
                            <label
                              className="form-label"
                              htmlFor="qualification"
                            >
                              Qualification
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="qualification"
                              value={employeedata?.[0]?.HighestEducation}
                              disabled
                            />
                          </div>
                        </td>

                        <td>
                          <div className="mb-3">
                            <label className="form-label" htmlFor="empID">
                              Emp ID
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="empID"
                              value={employeedata?.[0]?.EmployeeNumber}
                              disabled
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label" htmlFor="dateOfJoin">
                              Date of Join
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="dateOfJoin"
                              value={
                                employeedata?.[0]?.DateOfJoining?.split("T")[0]
                              }
                              disabled
                            />
                          </div>
                          <div className="mb-3">
                            <label
                              className="form-label"
                              htmlFor="previousExperience"
                            >
                              Previous years of Exp
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="previousExperience"
                              value={employeedata?.[0]?.total_experience}
                              disabled
                            />
                          </div>
                        </td>

                        <td>
                          <div className="mb-3">
                            <label className="form-label" htmlFor="roName">
                              RO's Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="roName"
                              value={employeedata?.[0]?.supervisor_name || ""}
                              disabled
                            />
                          </div>
                          <div className="mb-3">
                            <label
                              className="form-label"
                              htmlFor="roDesignation"
                            >
                              RO Designation
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="roDesignation"
                              value={employeedata?.[0]?.RODesignation || "IT"}
                              disabled
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </form>
              </div>
            </div>
          </div>
        </section>
        <form onSubmit={handleSubmit}>
          <div>
            {filteredRoleIndicators.length > 0 ? (
              filteredRoleIndicators.map((role) => (
                <section className="card border-0 mb-4" key={role.Id}>
                  <div className="card-header border border-bottom-0 text-center">
                    <h3 className="mb-2">
                      {role.Name} - Professional Excellence
                    </h3>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="table-responsive">
                        <table className="table table-bordered mb-0">
                          <thead>
                            <tr>
                              <th className="width-pixel">#</th>
                              <th>Key Result Area</th>
                              <th>Key Performance Indicators</th>
                              <th>Weightage</th>
                              <th>Points Scored ( self )</th>
                            </tr>
                          </thead>
                          <tbody>
                            {role.role_groups.length > 0 ? (
                              role.role_groups.map((group: any) => (
                                <tr key={`${role.Id}-${group.serial_no}`}>
                                  <td>{group.serial_no}</td>
                                  <td>
                                    {group.indicators.length > 0
                                      ? group.indicators[0]?.kra.name
                                      : "No KRA"}
                                  </td>
                                  <td>
                                    {group.indicators.length > 0
                                      ? group.indicators[0]?.indicator.name
                                      : "No Indicator"}
                                  </td>
                                  <td>{group.weightage}</td>
                                  <td>
                                    <input
                                      type="number"
                                      className="form-control"
                                      placeholder="Enter value"
                                      value={
                                        formData[
                                          `${role.Id}_${group.serial_no}`
                                        ] || ""
                                      }
                                      min="0"
                                      max={group.weightage}
                                      onChange={(e) =>
                                        handleInputChange(
                                          role.Id,
                                          group.serial_no,
                                          e.target.value,
                                          group.weightage
                                        )
                                      }
                                      onInput={(e: any) => {
                                        if (
                                          parseInt(e.target.value, 10) >
                                          group.weightage
                                        ) {
                                          e.target.value = group.weightage;
                                        }
                                      }}
                                      required
                                    />
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={5} className="text-center">
                                  .....No Data Available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </section>
              ))
            ) : (
              <div className="text-center">No Data Available</div>
            )}
          </div>

          {/* Save button aligned to the right */}
          <div className="d-flex justify-content-end mt-3">
            <button type="submit" className="btn btn-primary">
              Save
            </button>
          </div>
        </form>

        <section className="card border-0 mt-4">
          <div className="card-header border border-bottom-0 text-center">
            <h3 className="mb-2">Achievements (if any)</h3>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive">
                <table className="table table-bordered table-review mb-0">
                  <thead>
                    <tr>
                      <th className="width-pixel">#</th>
                      <th>By Self</th>
                      <th className="width-64">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row) => (
                      <tr key={row.id}>
                        <td>{row.id}</td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={row.value}
                            onChange={(e) =>
                              handleInputChangeComment(row.id, e.target.value)
                            }
                            required
                          />
                        </td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-danger btn-sm mx-1"
                            onClick={() => handleRemoveRow(row.id)}
                            disabled={rows.length === 1}
                          >
                            <i className="fa-solid fa-minus" />
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={handleAddRow}
                          >
                            <i className="fa-solid fa-plus" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {/* Save Button */}

              <div className="d-flex justify-content-end mt-3">
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={handleSubmitachivement}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </section>

        <section className="card border-0 mt-4">
          <div className="card-header border border-bottom-0 text-center">
            <h3 className="mb-2">Comments on the Role</h3>
            <p className="text-muted">
              Alterations if any required like Addition/Deletion of
              Responsibilities
            </p>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive">
                <table
                  className="table table-bordered mb-0"
                  id="table_alterations"
                >
                  <thead>
                    <tr>
                      <th className="width-pixel">#</th>
                      <th>By Self</th>
                    </tr>
                  </thead>
                  <tbody id="table_alterations_tbody">
                    <tr>
                      <td>1</td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          value={comment}
                          onChange={(e) => setComment(e.target.value)}
                          required
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-end mt-3">
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={handleSaveComment}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </section>

        <section className="card border-0">
          <div className="card-header border border-bottom-0 text-center">
            <h3 className="mb-2">Personal Goals</h3>
          </div>
          <form onSubmit={handleSubmitgoal}>
            <div className="row">
              <div className="col-md-12">
                <div className="table-responsive">
                  <table className="table table-bordered mb-0">
                    <thead>
                      <tr>
                        <th className="width-pixel">#</th>
                        <th>Goal Achieved during last year</th>
                        <th>Goal set for current year</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {goals.map((goal, index) => (
                        <tr key={goal.id}>
                          <td>{index + 1}</td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              value={goal.lastYearGoal}
                              onChange={(e) =>
                                handleInputChangegoal(
                                  goal.id,
                                  "lastYearGoal",
                                  e.target.value
                                )
                              }
                              required
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              value={goal.currentYearGoal}
                              onChange={(e) =>
                                handleInputChangegoal(
                                  goal.id,
                                  "currentYearGoal",
                                  e.target.value
                                )
                              }
                            />
                          </td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-danger btn-sm me-2"
                              onClick={() => removeRow(goal.id)}
                              disabled={goals.length === 1}
                            >
                              -
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary btn-sm"
                              onClick={addRow}
                            >
                              +
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="d-flex justify-content-end mt-3">
                    <button type="submit" className="btn btn-primary">
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>

        <div className="row mb-4 mt-5">
          <div className="col-md-12">
            <div className="table-responsive">
              <table className="table table-bordered mb-0">
                <thead>
                  <tr>
                    <th />
                    <th>Name</th>
                    <th>Frequency</th>
                    <th>Self Rating</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Employee</td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        value={employeedata?.[0]?.Name}
                        // onChange={handleEmployeeInputChange}
                        disabled
                      />
                    </td>
                    <td>
                      <select
                        className="form-control"
                        name="frequency"
                        value={employeeformData.frequency}
                        onChange={handleEmployeeInputChange}
                        required
                      >
                        <option value="Monthly">Monthly</option>
                        <option value="Quarterly">Quarterly</option>
                        <option value="Annually">Annually</option>
                      </select>
                    </td>
                    <td>
                      <StarRating
                        rating={employeeformData.rating}
                        onRate={handleEmployeeRatingChange}
                      />
                    </td>
                    <td>
                      <input
                        type="date"
                        className="form-control"
                        name="date"
                        value={employeeformData.date}
                        readOnly
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="d-flex justify-content-end mt-3">
            <button
              type="button"
              className="btn btn-success"
              onClick={handleemployeeSubmit}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
      <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3 mt-4">
        <p className="mb-0">2024 - 2025© hrmtree.</p>
        <p>
          Developed By{" "}
          <Link to="#" className="text-primary">
            Leadchain Systems
          </Link>
        </p>
      </div>
    </>
  );
};

export default PerformanceSelfReview;
